import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import logo from "../assets/logo.png";
import { useTranslation } from "../components/hooks/useTranslation";

const Header: React.FC = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#2C3E50" }}>
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            py: 1,
            px: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img src={logo} alt="Logo" style={{ height: 40 }} />
            <Typography
              variant={isSmallMobile ? "subtitle2" : "subtitle1"}
              sx={{ ml: 2, fontWeight: 500 }}
              noWrap
            >
              Car Accident Counsel
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
